import { inherits as _inherits, classCallCheck as _classCallCheck, createClass as _createClass, createSuper as _createSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Page as Page$1 } from './Page.js';

/* eslint max-classes-per-file: ["error", 4] */

var SlowPage = /*#__PURE__*/function (_Page) {
  _inherits(SlowPage, _Page);

  var _super = _createSuper(SlowPage);

  function SlowPage() {
    _classCallCheck(this, SlowPage);

    return _super.apply(this, arguments);
  }

  _createClass(SlowPage, [{
    key: "gulpItems",
    value: function gulpItems() {
      var _a, _b;

      var availableWidth = this.availableWidth,
          firstItemIndex = this.firstItemIndex,
          itemTracker = this.itemTracker; // Loop over items and gulp them into this page if they'll fit

      for (var i = firstItemIndex; i <= itemTracker.lastIndex; i++) {
        // Let's add the width of this one to our accumulated total so far; if it's too wide for the
        // available space, we're done!
        var itemWidth = (_a = itemTracker.getItemWidth(i)) !== null && _a !== void 0 ? _a : 0;
        var totalWidthPlusThisOne = ((_b = this._width) !== null && _b !== void 0 ? _b : 0) + itemWidth;
        if (totalWidthPlusThisOne > availableWidth) break; // If we've gotten this far, the item will fit and we should add its width to the total,
        // record its index, and keep rolling.

        this._width = totalWidthPlusThisOne;
        this._lastItemIndex = i;
      }
    }
    /** The number of items on this page. Becuase either value could be zero, we check for finite-ness
    before returning. */

  }, {
    key: "lastItemIndex",
    get: function get() {
      if (this._lastItemIndex === undefined) this.gulpItems();
      return this._lastItemIndex;
    }
    /** Page width in pixels */

  }, {
    key: "width",
    get: function get() {
      if (this._width === undefined) this.gulpItems();
      return this._width;
    }
  }, {
    key: "itemSlotsAvailable",
    get: function get() {
      return this.lastItemIndex - this.firstItemIndex + 1;
    }
  }], [{
    key: "create",
    value: function create(measurements, itemTracker, previousPage) {
      /** eslint-disable no-use-before-define */
      var page;

      if (!previousPage) {
        page = new SlowFirstPage(measurements, itemTracker);
      } else {
        page = new SlowMiddlePage(measurements, itemTracker, previousPage);
        if (page.isLast) page = new SlowLastPage(measurements, itemTracker, previousPage);
      }

      return page;
    }
  }]);

  return SlowPage;
}(Page$1);
var SlowMiddlePage = /*#__PURE__*/function (_SlowPage) {
  _inherits(SlowMiddlePage, _SlowPage);

  var _super2 = _createSuper(SlowMiddlePage);

  function SlowMiddlePage() {
    _classCallCheck(this, SlowMiddlePage);

    return _super2.apply(this, arguments);
  }

  return SlowMiddlePage;
}(SlowPage);
var SlowFirstPage = /*#__PURE__*/function (_SlowPage2) {
  _inherits(SlowFirstPage, _SlowPage2);

  var _super3 = _createSuper(SlowFirstPage);

  function SlowFirstPage() {
    var _this;

    _classCallCheck(this, SlowFirstPage);

    _this = _super3.apply(this, arguments);
    _this.buttonCount = 1;
    _this.isFirst = true;
    return _this;
  }

  return SlowFirstPage;
}(SlowPage);
var SlowLastPage = /*#__PURE__*/function (_SlowMiddlePage) {
  _inherits(SlowLastPage, _SlowMiddlePage);

  var _super4 = _createSuper(SlowLastPage);

  function SlowLastPage() {
    var _this2;

    _classCallCheck(this, SlowLastPage);

    _this2 = _super4.apply(this, arguments);
    _this2.buttonCount = 1;
    return _this2;
  }

  return SlowLastPage;
}(SlowMiddlePage);

export { SlowFirstPage, SlowLastPage, SlowMiddlePage, SlowPage };
